export default function(_) {
  return Object.prototype.toString.call(_) === '[object RegExp]';
}



// WEBPACK FOOTER //
// ./~/vega-util/src/isRegExp.js